import React, { useState, useEffect } from 'react';
import { formatDateForMySQL } from '../utils/api'; // 引入日期格式化函数
import './ReviewForm.css'; // 引入样式文件

function ReviewForm({ item, onSubmit, onCancel }) {
    const [id, setId] = useState('');
    const [chat_data_id, setChat_data_id] = useState('');
    const [Query, setQuery] = useState('');
    const [Answer, setAnswer] = useState('');
    const [Author, setAuthor] = useState('');
    const [Create_time, setCreate_time] = useState('');
    const [review_user_id, setReview_user_id] = useState('');
    const [review_username, setReview_username] = useState('');
    const [review_time, setReview_time] = useState('');
    const [review_conclusion, setReviewOpinion] = useState('');
    const [error, setError] = useState(''); // 用于存储错误提示信息

    // 使用 useEffect 初始化 query 和 answer 的值
    useEffect(() => {
        if (item) {
            setId(item.id||-1); // 如果 item.id 存在，则初始化，否则为空字符串
            setChat_data_id(item.chat_data_id ||-1); // 如果 item.chat_data_id 存在，则初始化，否则为空字符串
            setQuery(item.Query || ''); // 如果 item.query 存在，则初始化，否则为空字符串
            setAnswer(item.Answer || ''); // 如果 item.answer 存在，则初始化，否则为空字符串
            setAuthor(item.Author || ''); // 如果 item.author 存在，则初始化，否则为空字符串
            setCreate_time(item.Create_time || ''); // 如果 item.create_time 存在，则初始化，否则为空字符串
            setReview_user_id(item.review_user_id || ''); // 如果 item.review_user_id 存在，则初始化，否则为空字符串
            setReview_username(item.review_username || ''); // 如果 item.review_user_name 存在，则初始化，否则为空字符串
            setReview_time(item.review_time || ''); // 如果 item.review_time 存在，则初始化，否则为空字符串
            setReviewOpinion(item.review_conclusion || ''); // 如果 item.review_conclusion 存在，则初始化，否则为空字符串
        }
    }, [item]);

    const handleSubmit = (e) => {
        e.preventDefault(); // 阻止默认表单提交行为

        // 校验审核意见是否已设置
        if (!review_conclusion) {
            setError('必须设置有效的审核意见才能提交！');
            return;
        }

        // 清除错误提示
        setError('');


        const reviewData = {
            id,
            chat_data_id,
            Query,
            Answer,
            Author,
            Create_time,
            review_conclusion: review_conclusion,
            review_user_id: localStorage.getItem('user_id'), // 假设用户 ID 存储在 localStorage
            review_username: localStorage.getItem('user_name'), // 假设用户名存储在 localStorage
            review_time: formatDateForMySQL(new Date()), // 转换后的时间格式
        };

        // 调用父组件的 onSubmit 函数
        onSubmit(reviewData);
    };

    return (
        <div className="review-form-overlay">
            <div className="review-form">
                <h2>审核编辑</h2>
                <form onSubmit={handleSubmit}>
                    <div className="form-group">
                        <label>Query:</label>
                        <textarea
                            value={Query}
                            onChange={(e) => setQuery(e.target.value)}
                            rows="4"
                            cols="50"
                            required
                        />
                    </div>
                    <div className="form-group">
                        <label>Answer:</label>
                        <textarea
                            value={Answer}
                            onChange={(e) => setAnswer(e.target.value)}
                            rows="4"
                            cols="50"
                            required
                        />
                    </div>
                    <div className="form-group">
                        <label>审核意见:</label>
                        <select
                            value={review_conclusion}
                            onChange={(e) => setReviewOpinion(e.target.value)}
                            required
                        >
                            <option value="">请选择</option>
                            {id === -1 ? (
                                // 如果 id === -1，只允许选择“新加”
                                <option value="新加">新加</option>
                            ) : (
                                // 否则显示所有选项
                                <>
                                    <option value="已审核">已审核</option>
                                    <option value="放弃">放弃</option>
                                </>
                            )}
                        </select>
                    </div>
                    {error && <p className="error-message">{error}</p>} {/* 显示错误提示 */}
                    <div className="form-actions">
                        <button type="submit">提交</button>
                        <button type="button" onClick={onCancel}>
                            取消
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
}

export default ReviewForm;